import { ITupleResponseDTO } from './tuple-response-dto.interface';

export interface IFilesystemItemResponseDTO extends ITupleResponseDTO {
  updatedAt: Date;
  createdAt: Date;
  size: number;
  isDirectory: boolean;
}